import React, { useState } from 'react';
import { MailOutlined, SettingOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

import styles from 'src/app/components/DesignSidebar/DesignSidebar.module.scss';
import { commandsSubMenu, sidebarOpenButton, submenu } from 'src/app/components/DesignSidebar/design-sidebar.config';
import ControlCommands from '../ControlCommands/ControlCommands';
import CreateRelation from '../CreateRelation/CreateRelation';

import Button from 'antd/es/button/button';
import Menu from 'antd/es/menu';

const { SubMenu } = Menu;

const DesignSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <>
      <Button
        type="primary"
        onClick={() => setCollapsed(!collapsed)}
        style={{ ...sidebarOpenButton, left: collapsed ? '7vh' : '35vh' }}
      >
        {collapsed ? <RightOutlined /> : <LeftOutlined />}
      </Button>
      <Menu
        inlineCollapsed={collapsed}
        theme="light"
        className={styles.designSidebar}
        style={{
          width: collapsed ? '10vh' : '50vh',
          background: 'var(--secondary-color)',
        }}
        mode="inline"
      >
        <SubMenu style={submenu} key="sub1" icon={<MailOutlined />} title="CONTROL COMMANDS">
          <ControlCommands />
        </SubMenu>

        <SubMenu style={commandsSubMenu} key="sub3" icon={<SettingOutlined />} title="CREATE RELATION">
          <CreateRelation />
        </SubMenu>
      </Menu>
    </>
  );
};

export default DesignSidebar;
